// // import React, { useState } from "react";
// // import { filterArrowIcon } from "../../../../helpers/Icons";
// // import ConnectedCustomRefinementList from "../FilterRefinement";
// // const FilterSection = ({
// //   title,
// //   attribute,
// //   filterType,
// //   activeFilters,
// //   setIndustryCheckBoxValue,
// //   CategoryCheckBoxValue,
// //   setCategoryCheckBoxValue,
// //   handleFilters,
// //   MainFilters,
// //   setMainFilters,
// // }) => {

// //   const isPriceFilter = filterType === "Price";
// //   const [selectedValues, setSelectedValues] = useState([]);
// //   const priceOptions = [
// //     { name: "Below ₹50,000", value: "0 TO 50000" },
// //     { name: "₹50,001 to ₹100,000", value: "50001 TO 100000" },
// //     { name: "₹100,001 to ₹250,000", value: "100001 TO 250000" },
// //     { name: "₹250,001 to ₹500,000", value: "250001 TO 500000" },
// //     { name: "₹500,001 to ₹750,000", value: "500001 TO 750000" },
// //     { name: "₹750,001 to ₹1,000,000", value: "750001 TO 1000000" },
// //     { name: "Above ₹1,000,001", value: "1000001 TO 10000000" },
// //   ];
// //   const handlePrice = (event) => {
// //     const value = event.currentTarget.value;
// //     const newSelectedValues = [...selectedValues];
// //     if (event.currentTarget.checked) {
// //       newSelectedValues.push(value);
// //     } else {
// //       const index = newSelectedValues.indexOf(value);
// //       newSelectedValues.splice(index, 1);
// //     }

// //     setSelectedValues(newSelectedValues);
   
// //     let mainFiltersString = "";
// //     if (newSelectedValues.length > 0) {
// //       mainFiltersString = newSelectedValues
// //         .map((val) => `grossPrice:${val}`)
// //         .join(" OR ");
// //       mainFiltersString = `(${mainFiltersString})`;
// //     }

// //     setMainFilters(mainFiltersString);
// //   };

// //   return (
// //     <div className="filter">
// //       <div className="head">
// //         <span className="heading-600-16">{title}</span>
// //         {filterArrowIcon({
// //           width: 22,
// //           height: 10,
// //           className: activeFilters[filterType] ? "open" : "",
// //           onClick: () => handleFilters(filterType, !activeFilters[filterType]),
// //         })}
// //       </div>
      
// //       {activeFilters[filterType] ? (
// //         <div className="filter-body">
// //           {isPriceFilter ? (
// //             <div className="checkbox-wrap">
// //               {priceOptions.map((option, index) => (
// //                 <div className="checkbox-item" key={index}>
// //                   <label className="heading-400-16">{option.name}</label>
// //                   <input
// //                     type="checkbox"
// //                     value={option.value}
// //                     checked={selectedValues.includes(option.value)}
// //                     onChange={(e) => handlePrice(e)}
// //                   />
// //                 </div>
// //               ))}
// //             </div>
// //           ) : (
// //             <div className="checkbox-wrap">
// //               <ConnectedCustomRefinementList
// //                 attribute={attribute}
// //                 limit={100}
// //                 searchable={true}
// //                 setIndustryCheckBoxValue={setIndustryCheckBoxValue}
// //                 CategoryCheckBoxValue={CategoryCheckBoxValue}
// //                 setCategoryCheckBoxValue={setCategoryCheckBoxValue}
// //               />
// //             </div>
// //           )}
// //         </div>
// //       ) : null}
// //     </div>
// //   );
// // };

// // export default FilterSection;



// import React, { useEffect, useState } from 'react';
// import { filterArrowIcon } from "../../../../helpers/Icons";
// import ConnectedCustomRefinementList from "../FilterRefinement";
// import "../ProductListing.css"
// const FilterSection = ({
//   title,
//   attribute,
//   filterType,
//   activeFilters,
//   setIndustryCheckBoxValue,
//   CategoryCheckBoxValue,
//   setCategoryCheckBoxValue,
//   handleFilters,
//   MainFilters,
//   setMainFilters,
//   setIsGridView,
//   setIsPriceSelected,
// setIsIndustrySelected,
// setIsCategorySelected,
// setIsBrandsSelected,
// setIsModelSelected,
// setIsLocationSelected,
// setControllerSelected,
// setBarCapacitySelected,
// setMaxTurningLength,
// setXAXISSelected,
// setYAXISSelected,
// setZAXISSelected,
// filterConfigurations,
// }) => {
//   // Check if filterType is Price
//   const isPriceFilter = filterType === "Price";
//   const [selectedValues, setSelectedValues] = useState([]);
//   const [itemsCountMap, setItemsCountMap] = useState({});
//   // const allowedTitles = ["Industry", "Category", "Brands", "Model", "Location"];
//   const allowedTitles = ["Industry", "Category", "Brands", "Model", "Location","Controller","Bar Capacity","Max Turning Length","X AXIS (mm)","Y AXIS (mm)","Z AXIS (mm)","Tailstock"];

//   // Function to update item count for a specific title
//   const updateItemsCount = (title, count) => {
//     setItemsCountMap((prev) => {
//       const updatedMap = { ...prev, [title]: count };
//       // console.log("Updated itemsCountMap:", updatedMap);
//       return updatedMap;
//     });
//   };
//   // console.log("Current itemsCountMap:", itemsCountMap);
//   const [visibleItemsCount, setVisibleItemsCount] = useState(3);
//   const priceOptions = [
//     { name: "Below ₹10,00,000", value: "0 TO 1000000" },
//     /* { name: "₹50,001 to ₹100,000", value: "50001 TO 100000" }, */
//     /* { name: "₹100,001 to ₹250,000", value: "100001 TO 250000" }, */
//     /* { name: "₹250,001 to ₹500,000", value: "250001 TO 500000" }, */
// /*     { name: "₹5,00,001 to ₹10,00,000", value: "500001 TO 1000000" }, */
//    /*  { name: "₹750,001 to ₹1,000,000", value: "750001 TO 1000000" }, */
//     { name: "₹10,00,001 to ₹15,00,000", value: "1000001 TO 1500000" },
//     { name: "₹15,00,001 to ₹20,00,000", value: "1500001 TO 2000000" },
   
//     { name: "Above ₹20,00,001", value: "2000001 TO 10000000" }
//   ];

//   const handlePrice = (event) => {
//     const value = event.currentTarget.value;
//     const newSelectedValues = [...selectedValues];
//     if (event.currentTarget.checked) {
//       newSelectedValues.push(value);
//       setIsPriceSelected(true)
//     } else {
//       const index = newSelectedValues.indexOf(value);
//       newSelectedValues.splice(index, 1);
//       setIsPriceSelected(false)
//     }

//     setSelectedValues(newSelectedValues);

//     let mainFiltersString = "";
//     if (newSelectedValues.length > 0) {
//       mainFiltersString = newSelectedValues
//         .map((val) => `grossPrice:${val}`)
//         .join(" OR ");
//       mainFiltersString = `(${mainFiltersString})`;
//     }

//     setMainFilters(mainFiltersString);
//   };

//   const handleToggleFilter = () => {
//     handleFilters(filterType, !activeFilters[filterType]);
//   };

//   useEffect(() => {
//     if (isPriceFilter) {
//       console.log("Price Filters : -----------> ",priceOptions.map((option) => option.name));
//     }
//   }, [title]);

//   const [isExpanded,setIsExpanded] = useState(false);

//   const handleShowMore = () => {
//     setVisibleItemsCount(priceOptions.length); 
//     setIsExpanded(true);
//   };

//   const handleShowLess = () => {
//     setVisibleItemsCount(3)
//     setIsExpanded(false); 
//   }

//   const handleReset = () => {
//     // console.log("Reset button clicked");

//     // Clear all selected values
//     setSelectedValues([]);

//     // Reset main filters string
//     setMainFilters("");

//     // Reset checkboxes (force re-render)
//     setIsPriceSelected(false);

//     setTimeout(() => {
//       // console.log("After reset, selected values:", selectedValues);
//     }, 0); // Wait for next event loop to confirm state update
//   };

//   useEffect(() => {
//     // console.log("Selected values inside the reset useEffect hook:", selectedValues);

//     const resetBtn = document.getElementById("ResetBtn");

//     if (resetBtn) {
//       if (selectedValues.length > 0 || CategoryCheckBoxValue.length > 0) {
//         // console.log("Now showing the reset button");
//         resetBtn.style.display = "block";
//       } else {
//         // console.log("Now hiding the reset button");
//         resetBtn.style.display = "none";
//       }

//       resetBtn.addEventListener("click", handleReset);

//       return () => {
//         resetBtn.removeEventListener("click", handleReset);
//       };
//     }
//   }, [selectedValues]);

//   useEffect(() => {
//     // console.log("Updated selected values:", selectedValues);
//   }, [selectedValues]);


//   return (
//     <div className="filter">
//       {/* <div className="head">
//         <span className="heading-600-16">{title}</span>
//         {filterArrowIcon({
//           width: 22,
//           height: 10,
//           className: activeFilters[filterType] ? "open" : "",
//           onClick: handleToggleFilter, 
//         })}
//       </div> */}



// {
//   allowedTitles.map((title) => {
//     // Check if title exists and has a count greater than 0
//     if (allowedTitles.includes(title) && itemsCountMap[title] > 0) {
//       return (
//         <div className="head" style={{ justifyContent: "normal" }} key={title}>
//           {filterArrowIcon({
//             width: 22,
//             height: 10,
//             className: activeFilters[filterType] ? "open" : "",
//             onClick: handleToggleFilter,
//           })}
//           <span className="heading-600-16" onClick={handleToggleFilter}>{title}</span>
//         </div>
//       );
//     }
//     return null; // Don't render if count is 0 or title is not in the allowed list
//   })
// }

//       {activeFilters[filterType] && (
//         <div className="filter-body">
//           {isPriceFilter ? (
//             <div className="checkbox-wrap">
//             {priceOptions.slice(0, visibleItemsCount).map((option, index) => (
//               // <div className="checkbox-item" key={index}>
//               //   <label className="heading-400-16">{option.name}</label>
//               //   <input
//               //     type="checkbox"
//               //     value={option.value}
//               //     checked={selectedValues.includes(option.value)}
//               //     onChange={handlePrice}
//               //   />
//               // </div>

//               <div className="checkbox-item" key={index} style={{justifyContent:"normal"}}>

//               <input
//                                 type="checkbox"
//                                 value={option.value}
//                                 checked={selectedValues.includes(option.value)}
//                                 onChange={handlePrice}
//                               /> 
//                               {/* <label className="heading-400-16">{option.name}</label> */}
//                               <label className="heading-400-16 responsive-label">
//                     {option.name.includes(" to ") ? (
//                       <>
//                         <span className="break-on-small">
//                           {option.name.split(" to ")[0]}
//                         </span>
//                         <span className="break-on-small below-lineeee">
//                           to {option.name.split(" to ")[1]}
//                         </span>
//                       </>
//                     ) : option.name.includes("Below") ? (
//                       <>
//                         <span className="break-on-small">Below</span>
//                         <span className="break-on-small below-lineeeeforaboveandbelow">
//                           {option.name.replace("Below ", "")}
//                         </span>
//                       </>
//                     ) : option.name.includes("Above") ? (
//                       <>
//                         <span className="break-on-small">Above</span>
//                         <span className="break-on-small below-lineeeeforaboveandbelow">
//                           {option.name.replace("Above ", "")}
//                         </span>
//                       </>
//                     ) : (
//                       option.name
//                     )}
//                   </label>
              
//                             </div>
//             ))}
            
//             {priceOptions.length > visibleItemsCount && (
//               <button
//                 onClick={handleShowMore}
//                 className="load-more-button"
//               >
//                 + {priceOptions.length - visibleItemsCount} more
//               </button>
//             )}

//             {isExpanded && (
//                 <button
//                 onClick={handleShowLess}
//                 className="load-more-button"
//               >
//                 Show less
//               </button>
//             )}


//           </div>
          
//           ) : (
//             <div className="checkbox-wrap">
//              <ConnectedCustomRefinementList
//                 attribute={attribute}
//                 limit={100}
//                 title={title}
//                 searchable={true}
//                 setIndustryCheckBoxValue={setIndustryCheckBoxValue}
//                 CategoryCheckBoxValue={CategoryCheckBoxValue}
//                 setCategoryCheckBoxValue={setCategoryCheckBoxValue}
//                 setIsGridView={setIsGridView}

//                 setIsPriceSelected={setIsPriceSelected}
//                 setIsIndustrySelected={setIsIndustrySelected}
//                 setIsCategorySelected={setIsCategorySelected}
//                 setIsBrandsSelected={setIsBrandsSelected}
//                 setIsModelSelected={setIsModelSelected}
//                 setIsLocationSelected={setIsLocationSelected}

//                 setControllerSelected={setControllerSelected}
//                 setBarCapacitySelected={setBarCapacitySelected}
//                 setMaxTurningLength={setMaxTurningLength}
//                 setXAXISSelected={setXAXISSelected}
//                 setYAXISSelected={setYAXISSelected}
//                 setZAXISSelected={setZAXISSelected}
//                 filterConfigurations={filterConfigurations}
//                 updateItemsCount={updateItemsCount}
//               />
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default FilterSection;



import React, { useEffect, useState } from "react";
import { filterArrowIcon } from "../../../../helpers/Icons";
import ConnectedCustomRefinementList from "../FilterRefinement";

import ConnectedCustomRefinementListnewLogic from "../FilterRefinement/index_Feb_25_try_new_logic"

const FilterSection = ({
  title,
  attribute,
  filterType,
  activeFilters,
  setIndustryCheckBoxValue,
  CategoryCheckBoxValue,
  setCategoryCheckBoxValue,
  handleFilters,
  MainFilters,
  setMainFilters,
  setIsGridView,
  setIsPriceSelected,
  setIsIndustrySelected,
  setIsCategorySelected,
  setIsBrandsSelected,
  setIsModelSelected,
  setIsLocationSelected,
  setControllerSelected,
  setBarCapacitySelected,
  setMaxTurningLength,
  setXAXISSelected,
  setYAXISSelected,
  setZAXISSelected,
  filterConfigurations,
  updateFacetsAndMakeAPICall
}) => {
  // Check if filterType is Price
  const isPriceFilter = filterType === "Price";
  const [selectedValues, setSelectedValues] = useState([]);
  

  const [itemsCountMap, setItemsCountMap] = useState({});
  // const allowedTitles = ["Industry", "Category", "Brands", "Model", "Location"];
  const allowedTitles = ["Industry", "Category", "Brands", "Model", "Location","Controller","Bar Capacity","Max Turning Length","X AXIS (mm)","Y AXIS (mm)","Z AXIS (mm)","Tailstock"];

  // Function to update item count for a specific title
  const updateItemsCount = (title, count) => {
    setItemsCountMap((prev) => {
      const updatedMap = { ...prev, [title]: count };
      // console.log("Updated itemsCountMap:", updatedMap);
      return updatedMap;
    });
  };
  // console.log("Current itemsCountMap:", itemsCountMap);


  const [visibleItemsCount, setVisibleItemsCount] = useState(3);
  const priceOptions = [
    { name: "Below ₹10,00,000", value: "0 TO 1000000" },
    /* { name: "₹50,001 to ₹100,000", value: "50001 TO 100000" }, */
    /* { name: "₹100,001 to ₹250,000", value: "100001 TO 250000" }, */
    /* { name: "₹250,001 to ₹500,000", value: "250001 TO 500000" }, */
    /*     { name: "₹5,00,001 to ₹10,00,000", value: "500001 TO 1000000" }, */
    /*  { name: "₹750,001 to ₹1,000,000", value: "750001 TO 1000000" }, */
    { name: "₹10,00,001 to ₹15,00,000", value: "1000001 TO 1500000" },
    { name: "₹15,00,001 to ₹20,00,000", value: "1500001 TO 2000000" },
    // { name: "₹15,00,001 to ₹20,00,000", value: "1500001 TO 2000000" },
    { name: "Above ₹20,00,001", value: "2000001 TO 10000000" },
  ];

  const handlePrice = (event) => {
    const value = event.currentTarget.value;
    const newSelectedValues = [...selectedValues];
    if (event.currentTarget.checked) {
      // console.log("Now price is being selected ");
      newSelectedValues.push(value);
      setIsPriceSelected(true);
    } else {
      // console.log("Now price is being unselected ");
      const index = newSelectedValues.indexOf(value);
      newSelectedValues.splice(index, 1);
      setIsPriceSelected(false);
    }

    setSelectedValues(newSelectedValues);

    let mainFiltersString = "";
    if (newSelectedValues.length > 0) {
      mainFiltersString = newSelectedValues
        .map((val) => `grossPrice:${val}`)
        .join(" OR ");
      mainFiltersString = `(${mainFiltersString})`;
    }

    setMainFilters(mainFiltersString);
  };

  const handleToggleFilter = () => {
    handleFilters(filterType, !activeFilters[filterType]);
  };

  useEffect(() => {
    if (isPriceFilter) {
      // console.log("Price Filters : -----------> ",priceOptions.map((option) => option.name));
    }
  }, [title]);

  const [isExpanded, setIsExpanded] = useState(false);

  const handleShowMore = () => {
    setVisibleItemsCount(priceOptions.length);
    setIsExpanded(true);
  };

  const handleShowLess = () => {
    setVisibleItemsCount(3);
    setIsExpanded(false);
  };

  const handleReset = () => {
    // console.log("Reset button clicked");

    // Clear all selected values
    setSelectedValues([]);

    // Reset main filters string
    setMainFilters("");

    // Reset checkboxes (force re-render)
    setIsPriceSelected(false);

    setTimeout(() => {
      // console.log("After reset, selected values:", selectedValues);
    }, 0); // Wait for next event loop to confirm state update
  };

  useEffect(() => {
    // console.log("Selected values inside the reset useEffect hook:", selectedValues);

    const resetBtn = document.getElementById("ResetBtn");

    if (resetBtn) {
      if (selectedValues.length > 0 || CategoryCheckBoxValue.length > 0) {
        // console.log("Now showing the reset button");
        resetBtn.style.display = "block";
      } else {
        // console.log("Now hiding the reset button");
        resetBtn.style.display = "none";
      }

      resetBtn.addEventListener("click", handleReset);

      return () => {
        resetBtn.removeEventListener("click", handleReset);
      };
    }
  }, [selectedValues]);

  useEffect(() => {
    // console.log("Updated selected values:", selectedValues);
  }, [selectedValues]);

  return (
    <div className="filter">
      {/* <div className="head">
        <span className="heading-600-16">{title}</span>
        {filterArrowIcon({
          width: 22,
          height: 10,
          className: activeFilters[filterType] ? "open" : "",
          onClick: handleToggleFilter, 
        })}
      </div> */}


{
  allowedTitles.map((title) => {
    // Check if title exists and has a count greater than 0
    if (allowedTitles.includes(title) && itemsCountMap[title] > 0) {
      return (
        <div className="head" style={{ justifyContent: "normal" }} key={title}>
          {filterArrowIcon({
            width: 22,
            height: 10,
            className: activeFilters[filterType] ? "open" : "",
            onClick: handleToggleFilter,
          })}
          <span className="heading-600-16" onClick={handleToggleFilter}>{title}</span>
        </div>
      );
    }
    return null; // Don't render if count is 0 or title is not in the allowed list
  })
}
{/* {itemsCountMap[title] > 0 && (
        <div className="head" style={{ justifyContent: "normal" }}>
           {filterArrowIcon({
          width: 22,
          height: 10,
          className: activeFilters[filterType] ? "open" : "",
          onClick: handleToggleFilter,
        })}
          <span className="heading-600-16">{title}</span>
        </div>
      )} */}
      {/* <div className="head" style={{ justifyContent: "normal" }}>
        {filterArrowIcon({
          width: 22,
          height: 10,
          className: activeFilters[filterType] ? "open" : "",
          onClick: handleToggleFilter,
        })}
        &nbsp;
        <span className="heading-600-16">{title}</span>
      </div> */}

      {activeFilters[filterType] && (
        <div className="filter-body">

          {/* {console.log("activeFilters[filterType] : ",activeFilters[filterType] )} */}
          {isPriceFilter ? (
            <div className="checkbox-wrap">
              {priceOptions.slice(0, visibleItemsCount).map((option, index) => (
                // <div className="checkbox-item" key={index}>
                //   <label className="heading-400-16">{option.name}</label>
                //   <input
                //     type="checkbox"
                //     value={option.value}
                //     checked={selectedValues.includes(option.value)}
                //     onChange={handlePrice}
                //   />
                // </div>
                <div
                  className="checkbox-item"
                  key={index}
                  style={{ justifyContent: "flex-start" }}
                >
                  <input
                    type="checkbox"
                    value={option.value}
                    checked={selectedValues.includes(option.value)}
                    onChange={handlePrice}
                  />

                  <label className="heading-400-16 responsive-label">
                    {option.name.includes(" to ") ? (
                      <>
                        <span className="break-on-small">
                          {option.name.split(" to ")[0]}
                        </span>
                        <span className="break-on-small below-lineeee">
                          to {option.name.split(" to ")[1]}
                        </span>
                      </>
                    ) : option.name.includes("Below") ? (
                      <>
                        <span className="break-on-small">Below</span>
                        <span className="break-on-small below-lineeeeforaboveandbelow">
                          {option.name.replace("Below ", "")}
                        </span>
                      </>
                    ) : option.name.includes("Above") ? (
                      <>
                        <span className="break-on-small">Above</span>
                        <span className="break-on-small below-lineeeeforaboveandbelow">
                          {option.name.replace("Above ", "")}
                        </span>
                      </>
                    ) : (
                      option.name
                    )}
                  </label>
                </div>
              ))}

              {priceOptions.length > visibleItemsCount && (
                <button onClick={handleShowMore} className="load-more-button">
                  + {priceOptions.length - visibleItemsCount} more
                </button>
              )}

              {isExpanded && (
                <button onClick={handleShowLess} className="load-more-button">
                  Show less
                </button>
              )}
            </div>
          ) : (
            <div className="checkbox-wrap">
              <ConnectedCustomRefinementList
                attribute={attribute}
                limit={100}
                title={title}
                searchable={true}
                setIndustryCheckBoxValue={setIndustryCheckBoxValue}
                CategoryCheckBoxValue={CategoryCheckBoxValue}
                setCategoryCheckBoxValue={setCategoryCheckBoxValue}
                setIsGridView={setIsGridView}
                setIsPriceSelected={setIsPriceSelected}
                setIsIndustrySelected={setIsIndustrySelected}
                setIsCategorySelected={setIsCategorySelected}
                setIsBrandsSelected={setIsBrandsSelected}
                setIsModelSelected={setIsModelSelected}
                setIsLocationSelected={setIsLocationSelected}
                setControllerSelected={setControllerSelected}
                setBarCapacitySelected={setBarCapacitySelected}
                setMaxTurningLength={setMaxTurningLength}
                setXAXISSelected={setXAXISSelected}
                setYAXISSelected={setYAXISSelected}
                setZAXISSelected={setZAXISSelected}
                filterConfigurations={filterConfigurations}
                updateItemsCount={updateItemsCount}
                updateFacetsAndMakeAPICall={updateFacetsAndMakeAPICall}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
